export default "__VITE_ASSET__278f56fc__"